import { InputNumber, theme } from "antd";

type Props = {
  valueInCents?: number;
  disabled?: boolean;
  isCustom?: boolean;
  onChange: (valueInCents: number) => void;
}

const InputDistributionAmount = ({
  valueInCents = 0,
  disabled = false,
  isCustom = false,
  onChange,
}: Props) => {
  const { token } = theme.useToken();

  const style = {
    width: "100%",
    ...(isCustom && { backgroundColor: token.colorWarningBg }),
  };

  const currentValue = (Number(valueInCents) || 0) / 100;

  const formatter = (value: number | string | undefined) =>
    `${Number(value || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

  const parser = (value: string | undefined) =>
    Number(`${value}`.replace(/[^0-9.-]/g, ""));

  const handleChange = (value: number | string | null) =>
    onChange(Math.round((Number(value) || 0) * 100));

  const inputNumberProps = {
    min: 0,
    value: currentValue,
    prefix: "$",
    precision: 2,
    style,
    parser,
    disabled,
    formatter,
    onChange: handleChange,
  };

  return <InputNumber {...inputNumberProps} />;
};

export default InputDistributionAmount;
